(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /*
     * STAR SVG
     */

    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

    const STAR_PATH = [
      'M259.3 17.8L194 150.2 47.9 171.5',
      'c-26.2 3.8-36.7 36.1-17.7 54.6',
      'l105.7 103-25 145.5',
      'c-4.5 26.3 23.2 46 46.4 33.7',
      'L288 439.6l130.7 68.7',
      'c23.2 12.2 50.9-7.4 46.4-33.7',
      'l-25-145.5 105.7-103',
      'c19-18.5 8.5-50.8-17.7-54.6',
      'L382 150.2 316.7 17.8',
      'c-11.7-23.6-45.6-23.9-57.4 0z',
    ].join('');

    /*
     * CREATE STAR
     */

    function createStar(isFilled) {
      const svg = document.createElementNS(SVG_NAMESPACE, 'svg');

      svg.setAttribute('viewBox', '0 0 576 512');

      svg.setAttribute('aria-hidden', 'true');

      const path = document.createElementNS(SVG_NAMESPACE, 'path');

      path.setAttribute('d', STAR_PATH);

      path.setAttribute('fill', isFilled ? '#FFB800' : '#e0e0e0');

      svg.appendChild(path);

      return svg;
    }

    /*
     * RENDER REVIEW STARS
     */

    function renderReviewStars(card) {
      const starsContainer = card.querySelector('.cr-review-stars');

      if (!starsContainer) {
        return;
      }

      const parsedRating = parseInt(card.dataset.rating, 10);

      const rating = Number.isFinite(parsedRating) ? Math.max(0, Math.min(5, parsedRating)) : 0;

      starsContainer.replaceChildren();

      for (let star = 1; star <= 5; star++) {
        const svg = createStar(star <= rating);

        starsContainer.appendChild(svg);
      }

      starsContainer.setAttribute('role', 'img');

      starsContainer.setAttribute('aria-label', rating + ' out of 5 stars');
    }

    /*
     * GET REVIEW DATE
     */

    function getReviewDate(daysAgo) {
      const date = new Date();

      date.setHours(12, 0, 0, 0);

      date.setDate(date.getDate() - daysAgo);

      return date;
    }

    /*
     * DATE LANGUAGE
     */

    function getDateLocale() {
      const path = window.location.pathname.toLowerCase();

      if (path === '/en-us' || path.startsWith('/en-us/')) {
        return 'en-US';
      }

      return 'en-US';
    }

    /*
     * RENDER REVIEW DATE
     */

    function renderReviewDate(card) {
      const dateContainer = card.querySelector('.cr-review-date');

      if (!dateContainer) {
        return;
      }

      const parsedDays = parseInt(card.dataset.daysAgo, 10);

      const daysAgo = Number.isFinite(parsedDays) ? Math.max(0, parsedDays) : 0;

      const reviewDate = getReviewDate(daysAgo);

      const locale = getDateLocale();

      dateContainer.textContent = reviewDate.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    }

    /*
     * INITIALIZE INDIVIDUAL REVIEW
     */

    function initializeReviewCard(card) {
      renderReviewStars(card);

      renderReviewDate(card);
    }

    /*
     * INITIALIZE REVIEWS SECTION
     */

    function initializeReviews(section) {
      if (section.dataset.crInitialized === 'true') {
        return;
      }

      section.dataset.crInitialized = 'true';

      const cards = Array.from(section.querySelectorAll('.cr-review-card'));

      const loadMoreButton = section.querySelector('.cr-load-more-button');

      const parsedBatchSize = parseInt(section.dataset.batchSize, 10);

      const batchSize = Number.isFinite(parsedBatchSize) && parsedBatchSize > 0 ? parsedBatchSize : 3;

      /*
       * RENDER REVIEW DETAILS
       */

      cards.forEach(function (card) {
        initializeReviewCard(card);
      });

      /*
       * GET HIDDEN REVIEWS
       */

      function getHiddenCards() {
        return cards.filter(function (card) {
          return card.classList.contains('cr-hidden');
        });
      }

      /*
       * UPDATE BUTTON VISIBILITY
       */

      function updateLoadMoreButton() {
        if (!loadMoreButton) {
          return;
        }

        const hiddenCards = getHiddenCards();

        loadMoreButton.hidden = hiddenCards.length === 0;
      }

      /*
       * LOAD MORE REVIEWS
       */

      function loadMoreReviews() {
        const hiddenCards = getHiddenCards();

        const nextBatch = hiddenCards.slice(0, batchSize);

        nextBatch.forEach(function (card) {
          card.classList.remove('cr-hidden');
        });

        updateLoadMoreButton();
      }

      /*
       * BUTTON EVENT
       */

      if (loadMoreButton) {
        loadMoreButton.addEventListener('click', loadMoreReviews);
      }

      updateLoadMoreButton();
    }

    /*
     * INITIALIZE ALL SECTIONS
     */

    function initializeAllReviews(container) {
      const scope = container || document;

      if (scope.matches && scope.matches('[data-cr-reviews]')) {
        initializeReviews(scope);
      }

      const sections = scope.querySelectorAll('[data-cr-reviews]');

      sections.forEach(function (section) {
        initializeReviews(section);
      });
    }

    /*
     * PAGE LOAD
     */

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAllReviews(document);
      });
    } else {
      initializeAllReviews(document);
    }

    /*
     * SHOPIFY THEME EDITOR SUPPORT
     */

    document.addEventListener('shopify:section:load', function (event) {
      initializeAllReviews(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
